module.exports = __webpack_public_path__ + "01ea978f/img/SOURCERY_poweredby_web.9819842b.png";